import React from 'react';
import DietPlan from './DietPlan';

class Result extends React.Component{
    constructor(props) {
        super(props);
        this.state = {weightType: '', weightValue: ''}
    }

    static getDerivedStateFromProps(props, state) {
        if (props.measurementType === "metric"){
            return {weightType: 'kg', weightValue: 0.5}
        } else {
            return {weightType: 'lbs', weightValue: 1}
        }
        
    }

    render(){
        return(
            <div class="entry-form">
                <form>
                    <div class="calorie-result">
                        <h2>{this.props.calories} calorie</h2>
                    </div>

                    <table class="table">
                        <tr id='table-headers'>
                            
                            <th> </th>
                            <th>Gain Weight</th>
                            <th>Lose Weight</th>
                        </tr>
                        <tr className='table'>
                            <td>{this.state.weightValue} {this.state.weightType} per week</td>
                            <td>{this.props.calories + 500}</td>
                            <td>{this.props.calories - 500}</td>
                        </tr>
                        <tr>
                            <td>{this.state.weightValue * 2} {this.state.weightType} per week</td>
                            <td>{this.props.calories + 1000}</td>
                            <td>{this.props.calories - 1000}</td>
                        </tr>
                    </table>
                    <p>To Gain Weight:</p>
                    <DietPlan calorieRange={this.props.calories+500}/>
                    <p>To Lose Weight:</p>
                    <DietPlan calorieRange={this.props.calories-500}/>
                </form>

                
            </div>
        );
    }
}
export default Result;
